/// <reference path="../../index.d.ts" />

//@ts-ignore
import * as configurationpackage from '../../source/js/configurationpackage-api';

const configurationApi = {
	package: configurationpackage as typeof configurationpackageApi,
	subsystemService: {
		client: new configurationpackage.SubsystemServiceClient() as SubsystemServiceClient,
		fetchRemoteExternalServiceBySubsystemID: (subsystemInstanceID: number) => {
			return new Promise<RemoteExternalService>(resolve => {
				configurationApi.subsystemService.client.getSubsystemInstanceByID(subsystemInstanceID, (ssInstance: SubsystemInstance) => {
					const remoteExternalServiceID = ssInstance.Subsystem.ID;

					configurationApi.subsystemService.client.getRemoteExternalServiceByID(remoteExternalServiceID, (result: RemoteExternalService) => {
							resolve(result);
						});
					}
				);
			});
		},
		fetchSubsystemInstanceByID: (ID: number) => {
			return new Promise<SubsystemInstance>(resolve => {
				configurationApi.subsystemService.client.getSubsystemInstanceByID(ID, ssInstance => {
					resolve(ssInstance);
				});
			})
		}
	}
};

export default configurationApi;
